export default __webpack_public_path__ + "static/media/logoXL.81ba75f3.png";